module.exports = __webpack_public_path__ + "static/media/sardegna.b7ded832.svg";